import { useDispatch, useSelector } from "react-redux"
import {
    useFetchWithBody,
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, funValidateNoInput, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NextUITable,
} from "../../components"
import {
    Autocomplete,
    AutocompleteItem,
    Button,
    Input
} from "@nextui-org/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { format } from "date-fns";
import { toast } from "react-toastify"
import jsBarcode from 'jsbarcode';

const BarcodePrint = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)

    const [selItem, setSelItem] = useState("")
    const [numOfCatalog, setNumOfCatalog] = useState(1)


    const {
        isError,
        isLoading,
        data: itemData = []
    } = useFetchWithBody({
        url: apiRoute.catalogEntry.getItemList,
        queryKey: "Outward Catalog",


    })
    const funGetBarcode = (BarData) => {
        try {
            if (!BarData || BarData.length === 0) return;

            const printWindow = window.open('', '_blank');
            if (!printWindow) {
                alert('Please allow pop-ups for this site.');
                return;
            }

            const copies = numOfCatalog || 1;

            let htmlContent = `
                            <!DOCTYPE html>
                            <html>
                            <head>
                            <title>Catalog Print</title>
                            <style>
                            @page { size: 40mm 20mm; margin: 0; }
                            body { margin:0; padding:0; font-family: Arial; width: 40mm; }
                            .barcode-card {
                            width: 38mm;
                            height: 17mm;
                            padding: 1mm;
                            box-sizing: border-box;
                            page-break-after: always;
                            }
                            .barcode-container { width: 100%; height: 6mm; }
                            .barcode { width: 100%; height: 100%; }
                            .item { font-size:8px; font-weight:bold; }
                            .comp { font-size:10px; }
                            .flextop { display:flex; margin-left:2px; }
                            .pd { padding:0.1mm }
                            svg { shape-rendering: crispEdges; }
                            </style>
                            </head>
                            <body>
                            `;

            let barcodeScripts = "";

            // ✅ Repeat EACH item N times
            BarData.forEach((item, index) => {
                for (let copy = 0; copy < copies; copy++) {

                    const uniqueId = `barcode-${index}-${copy}`;

                    htmlContent += `
                        <div class="barcode-card">
                        <div class="flextop">
                            <div class="comp">${compName.join(",")}</div>
                        </div>

                        <div class="pd"></div>

                        <div class="flextop">
                            <div class="barcode-container">
                            <svg id="${uniqueId}" class="barcode"></svg>
                            </div>
                        </div>

                        <div class="pd"></div>

                        <div class="flextop">
                            <div class="item">${item.Item_Desc}</div>
                        </div>
                        </div>
                        `;

                    // ✅ Generate barcode script for each unique ID
                    barcodeScripts += `
                    try {
                    JsBarcode("#${uniqueId}", "${item.Item_Code}", {
                        format: "CODE128",
                        lineColor: "#000",
                        width: 1.5,
                        height: 20,
                        displayValue: false,
                        margin: 0
                    });
                    } catch(e) {
                    toast.error("Error: ${item.Item_Code}");
                    }
                    `;
                }
            });

            htmlContent += `
                        <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
                        <script>
                        window.onload = function() {
                        ${barcodeScripts}

                        setTimeout(() => {
                            window.print();
                            window.close();
                        }, 500);
                        };
                        </script>
                        </body>
                        </html>
                        `;

            printWindow.document.open();
            printWindow.document.write(htmlContent);
            printWindow.document.close();

        } catch (err) {
            toast.error('Barcode generation error:');
        }
    };
    const handleFilter = (e) => {
        e.preventDefault()
        const filteredRows = itemData.filter(ele =>
            (ele.Item_Code) == selItem
        );
        if (filteredRows && filteredRows.length > 0)
            funGetBarcode(filteredRows)
        else {
            toast.error("Items Not Found", {
                position: "top-center"
            })
        }

    }
    const handleClear = () => {
        setSelItem("")
        setNumOfCatalog(1)
    }





    if (isError) {
        return <ErrorCard />
    }

    // if (isLoading) {
    //     return <LoadingCard />
    // }


    return (
        <div>


            <MainContainer
                pageName="Product Catalog Barcode Print"
                info={[]}
                breadcrumbs={["Product Catalog", "Barcode Print"]}
            >
                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <form onSubmit={handleFilter}>
                        <div className="flex gap-2 w-full flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                            <Autocomplete
                                size="md"
                                name={"itemCode"}
                                label={"Item Name"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={"Item Name"}
                                menuTrigger="input"
                                isRequired
                                isLoading={isLoading}
                                className=" font-bold text-xs"
                                classNames={{
                                    label: "text-xs text-black font-bold",
                                }}
                                isClearable={false}
                                isVirtualized
                                // isReadOnly={isNewEntry ? false : true}
                                defaultItems={
                                    itemData || []
                                }
                                onSelectionChange={setSelItem}
                                color="danger"
                                //onChange={handleFormSelectionChange}
                                selectedKey={selItem}
                            >
                                {(list) => (
                                    <AutocompleteItem
                                        key={list["Item_Code"]}
                                    >
                                        {list["Item_Desc"]}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                            <Input
                                type="text"
                                name={"numOfCatalog"}
                                placeholder={"No Of Catalog"}
                                label={"No Of Catalog"}
                                labelPlacement="outside"
                                isRequired
                                value={numOfCatalog}
                                variant="bordered"
                                //disabled={isNewEntry ? false : true}
                                onChange={(e) => funValidateNoInput ? setNumOfCatalog(e.target.value) : ""}
                                color="warning"
                                size={"md"}
                                classNames={{
                                    label: "text-sm  font-bold",
                                }}
                            ></Input>
                            <div className="flex no-wrap gap-5 justify-center mt-5">
                                <Button type="submit" className="font-semibold uppercase bg-pink-600 text-white" variant="solid" color="primary" size="sm" >Print BarCode</Button>
                                <Button onPress={handleClear} className="font-semibold uppercase bg-slate-700  " variant="solid" color="danger" size="sm" >Cancel</Button>
                            </div>
                        </div>
                    </form>
                </div>


            </MainContainer>
        </div>
    )
}
export default BarcodePrint
